import { ref } from '@vue/composition-api'

// NOTE: feature flag のユーザー単位での切替を管理する。
// 既存の useCurrentData.js と同様、singleton ref + localStorage 永続化パターン。
// バックエンド側に flag 機構が整備されたら、この composable のみ差し替えればよい。

const STORAGE_KEY = 'featureFlags'

const DEFAULT_FLAGS = {
  // 卓作成ステップ方式ウィザード（既存 TableCreateDrawer と置き換え可能）
  useTableCreateWizard: false,
}

const parseStored = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : {}

    return { ...DEFAULT_FLAGS, ...parsed }
  } catch (_) {
    return { ...DEFAULT_FLAGS }
  }
}

const flags = ref(parseStored())

export const setFeatureFlag = (key, value) => {
  flags.value = { ...flags.value, [key]: Boolean(value) }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(flags.value))
}

export const setFeatureFlags = next => {
  const merged = { ...DEFAULT_FLAGS, ...(next || {}) }
  flags.value = merged
  localStorage.setItem(STORAGE_KEY, JSON.stringify(merged))
}

export default () => ({
  flags,
})
